<template>
  <section>
    <h1>{{ $t('requestExchangeComplete.title') }}</h1>
    <panel class="req-x-complete-panel">
      <div class="ok-icon">
        <div class="checkmark-wrapper">
          <div class="checkmark"></div>
        </div>
      </div>
      <p class="done">{{ $t('requestExchangeComplete.done') }}</p>
      <p class="actions">
        <enlil-button @click="onBackButtonClick">{{ $t('requestExchangeComplete.backToTop') }}</enlil-button>
      </p>
    </panel>
  </section>
</template>

<style lang="scss" scoped>
.req-x-complete-panel {
  max-width: 640px;
  margin-left: auto;
  margin-right: auto;
}

.ok-icon {
  width: 5em;
  height: 5em;
  border: #000 1px solid;
  border-radius: 50%;
  position: relative;
  margin: 1em auto;

  .checkmark-wrapper {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: rotateZ(-45deg);

    .checkmark {
      position: absolute;
      top: 32%;
      left: 23%;
      width: 60%;
      height: 30%;
      box-sizing: border-box;
      border-top: transparent 5px solid;
      border-right: transparent 5px solid;
      border-bottom: #000 5px solid;
      border-left: #000 5px solid;
      animation: checkmark 0.3s ease-out 1;
    }
  }
}

.done, .actions {
  text-align: center;
}

@keyframes checkmark {
  0% {
    width: 0;
    height: 0;
  }
  33% {
    width: 0;
    height: 30%;
  }
  100% {
    width: 60%;
    height: 30%;
  }
}
</style>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

import EnlilButton from '../../components/EnlilButton.vue'
import Panel from '../../components/Panel.vue'

export default {
  name: 'request-exchange-complete',
  components: {
    EnlilButton,
    Panel
  },
  computed: {
    ...mapState('requestForm', ['requestUUID'])
  },
  async mounted () {
    if (!this.requestUUID) {
      this.$router.replace('/request_exchange')
      return
    }

    this.clearRequestUUID()
    await this.fetchCurrentUserInfo()
    await this.fetchJewelHistories()
  },
  methods: {
    ...mapMutations('requestForm', ['clearRequestUUID']),
    ...mapActions('currentUserInfo', { fetchCurrentUserInfo: 'fetch' }),
    ...mapActions('jewelHistories', { fetchJewelHistories: 'fetch' }),
    onBackButtonClick () {
      this.$router.push('/')
    }
  }
}
</script>
